import { post } from 'app/utils/axios/kheti'

export interface DemoMaterialActionResult {
  id: number
  latest_status: string
}

interface RejectPayload {
  reason_config_id: number | null
  reason: string
}

const validateDemoMaterialRequest = async (
  action: 'approve' | 'reject',
  ids: number[],
  roleType?: string,
  reasonPayload?: RejectPayload,
) => {
  const url = `/approvals/v1/demo-material-issuance/action/${action}${roleType ? `?role_type=${roleType}` : ''}`
  const body: Record<string, unknown> = {
    request_ids: ids,
  }

  if (action === 'reject' && reasonPayload) {
    body.reason_config_id = reasonPayload.reason_config_id
    body.reason = reasonPayload.reason
  }

  return post<DemoMaterialActionResult[]>(url, body)
}

export default validateDemoMaterialRequest
